// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-CookieMessage----index-module---root---G4_Pu","rootShow":"src-components-CookieMessage----index-module---rootShow---3ar6m src-components-CookieMessage----index-module---root---G4_Pu","text":"src-components-CookieMessage----index-module---text---2QI0g","accept":"src-components-CookieMessage----index-module---accept---3Diau","link":"src-components-CookieMessage----index-module---link---XFnZ8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CookieMessage/index.module.css
// module id = 600
// module chunks = 114276838955818